import styled from "styled-components";

export const CustomInput = styled.input`
  padding: 0.5rem;
  max-width: 3rem;
  border: 0;
  box-shadow: 0 0 15px 4px rgb(0 0 0 / 11%);
  border-radius: 4px;
`;

export const CustomButton = styled.button`
  max-width: 200px;
  width: max-content;
  border: none;
  padding: 0.5rem 1rem;
  color: white;
  background-color: cadetblue;
`;

export const SectionContainer = styled.div`
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 4fr 1fr;
  grid-gap: 1rem;
  align-items: center;
  margin: 1rem;
  text-align: left;
  max-width: 400px;
`;
